import React, { FC, useEffect } from 'react';
import { Image, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PhoneImg from 'assets/images/get-app/phone-image.webp';
import { isMobileOrTablet } from '@medicusunion/front-utils';

import { Content, PhoneImage, StyledButton, StyledLink } from './styled';
import AppButtons from '../AppButtons';

const { Title, Paragraph } = Typography;

const DoctorApp: FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const { pathname, search } = window.location;

    const searchParams = new URLSearchParams(search);
    const checkDeepLinkParam = searchParams.get('checkDeepLink') !== '0';

    const checkDeepLink = isMobileOrTablet();

    if (
      pathname === '/new-password' &&
      searchParams.get('key') &&
      checkDeepLink &&
      checkDeepLinkParam
    ) {
      setTimeout(() => {
        window.location.href = window.location.href + '&checkDeepLink=0';
      }, 25);
      window.location.href = `medicusdoctor://new-password?key=${searchParams.get(
        'key'
      )}`;
    }
  }, []);

  return (
    <Content>
      <Title style={{ fontSize: 32 }} level={1}>
        {t('doctor_app.title')}
      </Title>
      <Paragraph style={{ fontSize: 16, fontWeight: 500 }}>
        {t('doctor_app.description')}
      </Paragraph>
      <AppButtons />
      <PhoneImage>
        <Image preview={false} src={PhoneImg} />
      </PhoneImage>
      <StyledLink
        target="_blank"
        rel="noreferrer"
        href="https://medicusunion.com/mobile-app-pro"
      >
        <StyledButton type="primary" shape="round">
          {t('doctor_app.download_now')}
        </StyledButton>
      </StyledLink>
    </Content>
  );
};

export default DoctorApp;
